import { scRecommend } from '@theme/wc-size-model';

class CasaSizeCalculator extends HTMLElement {
  connectedCallback() {
    if (this.dialog) return;
    this.dialog = this.querySelector('dialog');
    this.heightInput = this.querySelector('[data-height]');
    this.weightInput = this.querySelector('[data-weight]');
    this.strings = JSON.parse(this.querySelector('[data-calculator-strings]').textContent);
    this.selectButton = this.querySelector('[data-calculator-select]');
    this.querySelector('[data-calculator-close]').addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('close', () => this.trigger?.focus());
    this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
    this.addEventListener('input', () => this.update());
    this.selectButton.addEventListener('click', () => this.selectSize());
  }

  open(trigger) {
    this.trigger = trigger;
    this.form = trigger.closest('[data-casa-product-form]');
    this.querySelector('[data-calculator-product]').textContent = this.form.closest('.casa-product').querySelector('.casa-product__name').textContent.trim();
    this.update();
    this.dialog.showModal();
    this.heightInput.focus();
  }

  recommendedOption() {
    return [...(this.form?.querySelectorAll('input[type="radio"][name="size"]') || [])]
      .find(input => input.value === this.lastSize && !input.disabled);
  }

  update() {
    const valid = this.heightInput.checkValidity() && this.weightInput.checkValidity();
    const recommendation = valid ? scRecommend('regular', parseFloat(this.heightInput.value), parseFloat(this.weightInput.value)) : null;
    this.lastSize = recommendation?.size || null;
    this.querySelector('[data-calculator-message]').textContent = this.strings[this.lastSize ? 'recommended' : recommendation?.note || (valid ? 'hint' : 'invalid')];
    this.querySelector('[data-calculator-size]').textContent = this.lastSize || '';
    const available = Boolean(this.recommendedOption());
    this.selectButton.hidden = !this.lastSize;
    this.selectButton.disabled = !available;
    this.querySelector('[data-calculator-status]').textContent = this.lastSize && !available ? this.strings.unavailable : '';
  }

  selectSize() {
    const option = this.recommendedOption();
    if (!option) { this.update(); return; }
    option.checked = true;
    option.dispatchEvent(new Event('change', { bubbles: true }));
    this.dialog.close();
  }
}

if (!customElements.get('casa-size-calculator')) customElements.define('casa-size-calculator', CasaSizeCalculator);
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-casa-open-calculator]');
  if (trigger) document.querySelector('casa-size-calculator')?.open(trigger);
});
